import React from 'react'
import ListProvinceRules from '../../components/rules/ListProvinceRules'

const ProvinceRules = () => {
  return (
    <div>
      <ListProvinceRules />
    </div>
  )
}

export default ProvinceRules
